import { CONFIG } from '../../config/gameConfig';
import type { Drawable } from '../../types';

const TICK_COLOR = '#cfcfcf';
const SCORE_COLOR = '#888';
const NAME_COLOR = '#535353';
const COMPANY_COLOR = '#a8a8a8';

// 길 아래에 표시되는 "묘비" — 누가 어느 점수에서 죽었는지 보여준다.
// 시작 위치는 score 와 currentScore/speed 로 계산된 정확한 픽셀 거리.
export class Grave implements Drawable {
  x: number;

  constructor(
    private readonly score: number,
    private readonly companyName: string,
    private readonly nickname: string,
    startX: number,
  ) {
    this.x = startX;
  }

  update(speed: number): void {
    this.x -= speed;
  }

  isOffscreen(): boolean {
    return this.x < -80;
  }

  draw(ctx: CanvasRenderingContext2D): void {
    const groundY = CONFIG.game.groundY;
    const x = Math.round(this.x);

    ctx.fillStyle = TICK_COLOR;
    ctx.fillRect(x, groundY + 4, 1, 5);

    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';

    ctx.font = '10px ui-monospace, "Courier New", monospace';
    ctx.fillStyle = SCORE_COLOR;
    ctx.fillText(String(this.score), x, groundY + 12);

    ctx.font = '600 10px ui-sans-serif, system-ui, sans-serif';
    ctx.fillStyle = NAME_COLOR;
    ctx.fillText(this.nickname, x, groundY + 26);

    ctx.font = '9px ui-sans-serif, system-ui, sans-serif';
    ctx.fillStyle = COMPANY_COLOR;
    ctx.fillText(this.companyName, x, groundY + 39);
  }
}
